import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  Spacer,
  Text,
  Button,
  Modal,
  ModalBody,
  ModalClose,
  ModalFooter,
} from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';

const SingleAttachment = ({ data, fetchFile }) => {
  const [actualFile, setActualFile] = useState(null);
  const [fileSize, setFileSize] = useState(0);
  const [showAttached, setShowAttached] = useState(false);

  useEffect(() => {
    if (!data?.data) {
      fetchFile(data.attachmentId).then((res) => {
        if (res.raw) {
          setFileSize(Math.ceil(res.raw.size / 1000));
          const reader = new window.FileReader();
          reader.readAsDataURL(res.raw);
          reader.onload = function () {
            setActualFile(reader.result);
          };
        }
      });
    }
  }, [data, fetchFile]);

  return (
    <>
      <Box
        margin="10px 20px 0 0"
        pad="12px 25px"
        background={({ theme }) => theme.PrimaryFade}
        style={{ borderRadius: '3px' }}
      >
        <Grid default="3fr 2fr 1fr 80px" style={{ alignItems: 'center' }}>
          <Text uppercase bold size="13px">
            {data?.title || data?.alternateLabel}
          </Text>
          <Text>
            <b>Section</b>: {data.section}
          </Text>
          <Text>
            <b>Size</b>: {fileSize}KB
          </Text>
          <Button onClick={() => setShowAttached(true)} pale>
            Preview
          </Button>
        </Grid>
      </Box>
      <Modal
        outerclick
        onClose={() => setShowAttached(false)}
        open={showAttached}
      >
        <ModalBody style={{ height: 'fit-content' }} width="80vw">
          <ModalClose onClick={() => setShowAttached(false)}>
            &times;
          </ModalClose>
          <Box pad="20px">
            <h2>{data?.alternateLabel || data?.title}</h2>
            <Spacer />
            {(data?.mimetype?.indexOf('image') === 0 || data?.data) && (
              <img
                width="100%"
                src={data.data || actualFile}
                alt={data.title}
              />
            )}
            {data?.mimetype === 'application/pdf' && actualFile && (
              <object
                aria-label=""
                width="100%"
                height="400"
                data={actualFile}
                type="application/pdf"
              ></object>
            )}
          </Box>
          <ModalFooter>
            <Box width="min-content" pad="20px" margin=" 0 0 0  auto">
              <Button
                onClick={() => setShowAttached(false)}
                spaceLeft="auto"
                pale
              >
                Close
              </Button>
            </Box>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </>
  );
};

SingleAttachment.propTypes = {
  data: PropTypes.object,
  fetchFile: PropTypes.func,
};

export default function AttachmentsTab({ attachments, fetchFile }) {
  return (
    <Box margin="20px 20px 20px 0">
      <Grid default="1fr" gap="20px">
        {attachments.map((a) => (
          <SingleAttachment data={a} key={a.id} fetchFile={fetchFile} />
        ))}
      </Grid>
    </Box>
  );
}

AttachmentsTab.propTypes = {
  attachments: PropTypes.array,
  fetchFile: PropTypes.func,
  modalSize: PropTypes.bool,
};
